import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import triggerTypesSAService from "services/superadmin/triggerTypesSAService";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

interface TriggerTypeFormProps {
  router: any;
  data: { triggerType: any };
}

const TriggerTypeForm = ({ router, data }: TriggerTypeFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { triggerType } = data;

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    watch,
    control,
  } = useForm({
    defaultValues: {
      name: triggerType?.name,
      platform: triggerType?.platform,
      type: triggerType?.type,
      subType: triggerType?.subType,
      allowMultiple: triggerType?.allowMultiple || false,
      icon: triggerType?.icon,
      schema: triggerType?.schema || {
        fields: [
          {
            key: "keywords",
            label: "Ключевые слова",
            type: "string[]",
            required: true,
          },
          {
            key: "intention",
            label: "Намерение",
            type: "string",
            required: true,
          },
        ],
      },
    },
    mode: "onChange",
  });

  const onSubmit = async (formValues: any) => {
    console.log("formValues: ", formValues);
    try {
      if (triggerType) {
        await triggerTypesSAService.put(id, formValues);
        snack("Триггер обновлен успешно!");
      } else {
        await triggerTypesSAService.post(formValues);
        snack("Триггер создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={triggerType ? "Редактирование триггера" : "Создание триггера"}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <TextField
          label="Название"
          {...register("name", { required: { message: "Название обязательно", value: true } })}
        />

        <Controller
          control={control}
          name="platform"
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>Платформа</InputLabel>
              <Select {...field} label="Платформа">
                <MenuItem value="INSTAGRAM">Instagram</MenuItem>
                <MenuItem value="TELEGRAM">Telegram</MenuItem>
                <MenuItem value="WHATSAPP">WhatsApp</MenuItem>
                <MenuItem value="FACEBOOK">Facebook</MenuItem>
              </Select>
            </FormControl>
          )}
        />

        <Controller
          control={control}
          name="type"
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>Тип</InputLabel>
              <Select {...field} label="Тип">
                <MenuItem value="NEW_MESSAGE">NEW_MESSAGE</MenuItem>
                <MenuItem value="NEW_COMMENT">NEW_COMMENT</MenuItem>
              </Select>
            </FormControl>
          )}
        />

        <TextField label="Подтип" {...register("subType")} />

        <TextField label="Иконка" {...register("icon")} />

        <div>
          <Switch {...register("allowMultiple")} checked={getValues("allowMultiple")} />
          <label htmlFor="allowMultiple">Разрешить несколько триггеров</label>
        </div>

        {/* JSON Schema Editor */}
        <section>
          <div className="border border-gray-300 p-4 rounded-md">
            {watch("schema.fields").map((field: any, index: number) => (
              <div key={index} className="flex flex-col gap-2 mb-8">
                {/* Key */}
                <div className="flex flex-col gap-2">
                  <TextField label="Key" {...register(`schema.fields[${index}].key`)} />
                </div>
                {/* Label */}
                <div className="flex flex-col gap-2">
                  <TextField label="Label" {...register(`schema.fields[${index}].label`)} />
                </div>

                <Controller
                  control={control}
                  name={`schema.fields[${index}].type`}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Тип</InputLabel>
                      <Select {...field} label="Тип">
                        <MenuItem value="string">Строка</MenuItem>
                        <MenuItem value="number">Число</MenuItem>
                        <MenuItem value="string[]">Массив строк</MenuItem>
                        <MenuItem value="boolean">Логическое значение</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />

                <Button
                  type="button"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setValue(
                      "schema.fields",
                      getValues("schema.fields").filter((_: any, i: number) => i !== index),
                      {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: true,
                      }
                    );
                  }}
                >
                  Удалить поле
                </Button>
              </div>
            ))}

            <Button
              type="button"
              variant="outlined"
              color="primary"
              onClick={() => {
                setValue(
                  "schema.fields",
                  [...getValues("schema.fields"), { key: "", label: "", type: "string" }],
                  {
                    shouldDirty: true,
                    shouldTouch: true,
                    shouldValidate: true,
                  }
                );
              }}
            >
              Добавить новое поле
            </Button>
          </div>
        </section>

        <div>
          <pre>{JSON.stringify(watch(), null, 2)}</pre>
        </div>
        <Button type="submit" variant="contained" color="primary">
          Сохранить
        </Button>
      </form>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(TriggerTypeForm, (router: any) => {
    let requests: any = {};

    if (router.params.id) {
      requests["triggerType"] = () => triggerTypesSAService.get(router.params.id);
    }
    return useLoadAll(requests);
  })
);
